import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {TextButton} from "@irati/ui/src/Button"

import Number from "../IconWithNumber/Number"
import {Wrapper} from "../styled"

const Reaction = styled.div`
  font-size: 16px;
  height: 21px;
  line-height: 15px;
  margin-bottom: -1px;
  padding-top: 2px;
`

class ReactionIcon extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    reaction: PropTypes.shape({
      count: PropTypes.number.isRequired,
      emoji: PropTypes.string.isRequired
    }).isRequired
  }

  render() {
    const {active, onClick, reaction} = this.props

    return (
      <TextButton onClick={onClick}>
        <Wrapper active={active} isReaction>
          <Reaction>{reaction.emoji}</Reaction>
          <Number>{reaction.count}</Number>
        </Wrapper>
      </TextButton>
    )
  }
}

export default ReactionIcon
